/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useMemo, useRef, useEffect } from "react";
import {
  Nav,
  Tab,
  Dropdown,
  OverlayTrigger,
  Tooltip,
  Badge,
} from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import { FormattedMessage, useIntl } from "react-intl";
// Redux
import { useSelector } from "react-redux";
// Components
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { getIconByNotificationType } from "../../../../../app/utils/utilityFunctions";
import bgn from "./../../images/capture.png";
import "./userNotificationsDropdown.scss"

export function UserNotificationsDropdown() {
  const [key, setKey] = useState("Alerts");
  // const bgImage = toAbsoluteUrl("/media/misc/bg-1.jpg");
  const intl = useIntl();

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.notifications.layout") ===
        "offcanvas",
    };
  }, [uiService]);

  // Redux
  const { unreadNotifications, unread } = useSelector(
    (state) => state.notifications
  );
  const { currentStakeholder } = useSelector((state) => state.stakeholder);

  // Custom Inline Style Component
  const customBadge = {
    badge: {
      position: "absolute",
      top: "-5%",
      right: "-10%",
      padding: "4px 7px",
      lineHeight: "15px",
      borderRadius: "35px",
      fontSize: "12px",
      color: "#ffffff",
      backgroundColor: "#FF5959",
      borderColor: "#FF5959",
    },
  };
  // Custom Inline Style Component

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false); 
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      {layoutProps.offcanvas && (
        <div className="topbar-item">
          <div
            className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-primary"
            id="kt_quick_notifications_toggle"
          >
            <span className="svg-icon svg-icon-xl svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Compiling.svg")} title=" " />
            </span>
            <span className="pulse-ring"></span>
          </div>
        </div>
      )}
      {!layoutProps.offcanvas && (
        <Dropdown drop="down" alignRight show={open} ref={dropdownRef}>
          <Dropdown.Toggle
            onClick={() => setOpen(!open)}
            as={DropdownTopbarItemToggler}
            id="kt_quick_notifications_toggle"
          >
            <OverlayTrigger
              placement="bottom"
              overlay={
                // <Tooltip id="user-notification-tooltip">
                //   <FormattedMessage id="user_notifications" />
                // </Tooltip>
                <div></div>
              }
            >
              <div
                className="btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg mr-1 pulse pulse-primary"
                id="kt_quick_notifications_toggle"
                style={{
                  position: "relative",
                }}
              >
                <span className="svg-icon svg-icon-xl">
                  {/* <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Code/Compiling.svg")} title=" "
                  /> */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path d="M10.4287 5.76904C10.4287 4.66447 11.3241 3.76904 12.4287 3.76904C13.5333 3.76904 14.4287 4.66447 14.4287 5.76904C16.7689 6.8756 18.3073 9.18329 18.4287 11.769V14.769C18.5813 16.0298 19.3236 17.1432 20.4287 17.769H4.42871C5.53383 17.1432 6.2761 16.0298 6.42871 14.769V11.769C6.55008 9.18329 8.08854 6.8756 10.4287 5.76904" stroke="#F1EAFA" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.42871 17.769V18.769C9.42871 20.4259 10.7719 21.769 12.4287 21.769C14.0856 21.769 15.4287 20.4259 15.4287 18.769V17.769" stroke="#F1EAFA" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <span className="pulse-ring" />
                <span style={customBadge.badge}>{unread}</span>
              </div>
            </OverlayTrigger>
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg">
            <form>
              {/** Head */}
              <div
                className="d-flex flex-column pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top"
                style={{ backgroundImage: `url(${bgn})` }}
              >
                <h3 className="d-flex flex-center rounded-top">
                  <span className="text-white">
                    <FormattedMessage id="user_notifications" />
                  </span>
                  {/* <span className="btn btn-text btn-success btn-sm font-weight-bold btn-font-md ml-2">{unread}</span> */}
                </h3>
              </div>
              <Tab.Content className="tab-content">
                <PerfectScrollbar
                  options={{
                    wheelSpeed: 2,
                    wheelPropagation: false,
                  }}
                  className="scroll"
                  style={{ maxHeight: "300px", position: "relative" }}
                >
                  {unreadNotifications && unreadNotifications.length ? (
                    unreadNotifications.map((n, i) => (
                      <div
                        className="d-flex align-items-center pt-3 pb-3 pr-5 pl-5"
                        key={i}
                      >
                        <div className="symbol symbol-40 symbol-light-primary mr-5">
                          <div className="navi-icon mr-2">
                            {getIconByNotificationType[n.type]}
                          </div>
                        </div>
                        <div className="d-flex flex-column font-weight-bold">
                          <a
                            href={
                              currentStakeholder.active
                                ? `/stakeholder/cabinet/notifications/${n._id}`
                                : `/stakeholder/new/notifications/${n._id}`
                            }
                            className="text-dark text-hover-primary mb-1 font-size-lg"
                          >
                            <FormattedMessage id={n.type} />
                          </a>
                          <span className="text-muted">
                            {intl
                              .formatMessage({ id: n.content })
                              .substr(0, 30)}
                            {intl.formatMessage({ id: n.content }).length >
                              30 ? (
                              <span>...</span>
                            ) : null}
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="d-flex align-items-center pt-3 pb-3 pr-5 pl-5 justify-content-center">
                      <div className="d-flex flex-column font-weight-bold">
                        <span className="text-muted mb-1 font-size-lg m-100 p-6">
                          {<FormattedMessage id="no_any_notification" />}
                        </span>
                      </div>
                    </div>
                  )}
                </PerfectScrollbar>
                <div className="d-flex align-items-center pt-3 pb-3 pr-5 pl-5 justify-content-center border-top">
                  <div className="d-flex flex-column font-weight-bold">
                    <a
                      href={
                        currentStakeholder.active
                          ? "/stakeholder/cabinet/notifications"
                          : "/stakeholder/new/notifications"
                      }
                      className="text-muted text-hover-primary mb-1 font-size-lg m-100"
                    >
                      <FormattedMessage id="see_all_notifications" />
                    </a>
                  </div>
                </div>
              </Tab.Content>
            </form>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}
